import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { req } from "./ServerUtils";
import { CircularProgress } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down(500)); // Returns true for small screens
  const [userInfo, setUserInfo] = useState(null);
  const [lastFetched, setLastFetched] = useState(null);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const isExtension = true;

  function onFetch(res) {
    
    if (!res) {
      navigate('/login?redirect=' + location.pathname);
      return;
    }
    if (["basic", "premium", "free-trial"].includes(res.subscription_type)) {
        setUserInfo(res);
        setLastFetched(Date.now());
    } else {
        navigate('/choose-plan');
    }
    if (res?.adadfdr2) {
      navigate('/app-down');
      return;
    }
    setLoading(false);
  }  

  const fetchUserInfo = async () => {
    const currentUrl = location.pathname;
   
    if (currentUrl.includes("/login") || currentUrl.includes("/choose-plan")) {
      setLoading(false);
      return;
    }
    const now = Date.now();
    if (lastFetched && now - lastFetched < 5 * 60 * 1000) {
      if (userInfo) {
        onFetch(userInfo);
      }
      return;
    }

    setLoading(true);
    req('/user_info').then(res => {
        onFetch(res);
    }).catch(e => {
        navigate('/login?redirect=' + location.pathname);

        setLoading(false);
        
    })

  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  if (loading) return <div>
    <CircularProgress /> 
  </div>;

  return (
    <UserContext.Provider value={{ userInfo, setUserInfo, refetchUserInfo: fetchUserInfo, isExtension, smallScreen }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
